import * as types from './types';
import Api from '../../../lib/api';

import {PREQUALIFICATION_COMPLETED} from '../../../lib/appConstants';
import _ from 'lodash';

export const setFetchingHeader = (isFetching) => {
  return {
    type: types.SET_FETCHING_SC_HEADER,
    isFetching
  };
};

export const setHeaderDetails = (headerDetails) => {
  return {
    type: types.SET_SC_HEADER_DETAILS,
    headerDetails
  };
};

export const setUpdateSCstatus = (status) => {
  return {
    type: types.SET_UPDATE_SC_STATUS,
    status: {
      subcontratorStatus: status.subcontratorStatus,
      subcontratorStatusId: status.subcontratorStatusId
    }
  };
};

export const fetchHeaderDetails = (subcontractorId, hiringClientId, origin) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setFetchingHeader(true));
    dispatch(setHeaderDetails({}));
    const url = `subcontractors/headerdetails?subcontractorId=${subcontractorId}&hiringClientId=${hiringClientId}`
    // console.log('url = ', url)
    if (origin) {

      // console.log('origin = ', origin, " hiringClientId = ", hiringClientId)
    } else {
      // console.log('origin UNKNOWN, hiringClientId = ', hiringClientId)
    }
    return Api.get(
      url,
      token
    ).then(response => {
      const {success, data } = response.data;
      if (success && data) {
        data.id = subcontractorId
        if(data.subcontratorStatus && data.subcontratorStatus !== PREQUALIFICATION_COMPLETED) {
          data.tierRating = null;
          data.singleProjectLimit= null;
          data.aggregateProjectExposure = null;
          data.companyType = null;
        }
        if(data.hiringClientsList.length){
          data.hiringClientsList = _.orderBy(data.hiringClientsList, ['name']);
        }
        dispatch(setHeaderDetails(data || {}));
        // console.log('data = ', data)
        dispatch(setHiringClientId(data.currentHiringClient));
        dispatch(setSubContractorHasHiringClientSiblings(!!data.scHasHCSiblings));

        // if (!data.address && !data.city && !data.state && !data.zipCode && !data.phone) {
        //   dispatch(setChangingPrimary(true));
        // }
        // if (closeCallback) {
        //   closeCallback()
        // }
      } else {
        // if (closeCallback) {
        //   closeCallback()
        // }
      }
      dispatch(setFetchingHeader(false));
    })
    .catch(error => {
    //console.log(error);
      dispatch(setFetchingHeader(false));
      // if (closeCallback) {
      //   closeCallback()
      // }
    });
  };
}

export const setFetchingHiringClients = (isFetching) => {
  return {
    type: types.SET_FETCHING_SC_HIRINGCLIENTS,
    isFetching
  };
};

export const setHiringClients = (hcList) => {
  return {
    type: types.SET_SC_HIRINGCLIENTS,
    hcList
  };
};

export const fetchHiringClientsForSCprofile = (subcontractorId, userId, initHeader) => {
  return (dispatch, getState) => {
    const { authToken } = getState().login;
    dispatch(setFetchingHiringClients(true));
    dispatch(setHiringClients([]));
    if (initHeader) {
      dispatch(setHeaderDetails({}));
      dispatch(setFetchingHeader(true));
    }

    const initHeaderCallback = (foundHCs) => {
      // console.log('foundHCs = ', foundHCs)
      if(initHeader){
        let hcId = getState().SCProfile.hcId;
        // console.log('getState().SCProfile.hcId = ', hcId)
        const { lastPayment } = getState().SCProfile;

        if(hcId === ""){
          const paymentHc = foundHCs.find(hc => hc.id === Number(lastPayment.hcId));

          if (paymentHc) {
            hcId = paymentHc.id;
            dispatch(setHiringClientId(paymentHc.id));
          } else {
            hcId = foundHCs.length > 0 ? foundHCs[0].id: '' ;
            // console.log('foundHCs[0].id = ', foundHCs[0].id)
            dispatch(setHiringClientId(hcId));
          }
        }
        dispatch(fetchHeaderDetails(subcontractorId, hcId, 'fetchHiringClientsForSCprofile'));
      }
    }
    // return Api.get(`users/profile`, authToken).then((response)=> {
      // const { Id, RoleID } = response.data.data.profile;
      const url = `hiringclients?userId=${userId}&subcontractorId=${subcontractorId}`
      // console.log('fetchHiringClientsForSCprofile url = ', url)
      Api.get(
        url,
        authToken

      ).then(response => {
        const {success, data } = response.data;
        if (success && data) {
          // console.log('data = ', data)
          // The variable that this setter is setting is not called from the REDUCER!  This is a DEAD END!!!
          // dispatch(setHiringClients(data.hiringClients || []));
          // The variable that this setter is setting is not called from the REDUCER!  This is a DEAD END!!!
          initHeaderCallback(data.hiringClients || []);
        }

        dispatch(setFetchingHiringClients(false));
      })
      .catch(error => {
      //console.log(error);
        initHeaderCallback([]);
        dispatch(setFetchingHiringClients(false));
      });

    // }).catch(error => {
    // //console.log(error);
    //   initHeaderCallback([]);
    //   dispatch(setFetchingHiringClients(false));
    // });
  };
}

export const setHiringClientId = (hcId) => {
  return {
    type: types.SET_SC_HC_ID,
    hcId
  };
};

/* CHANGE BASIC DATA SUPPORT */
export const changeBasicData = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    return Api.put(
      'subcontractors/updatebasicdata',
      payload,
      token
    ).then(response => {
      const { success } = response.data;
      if (callback) callback(success);
    })
      .catch(error => {
        if (callback) callback(false);
      });
  };
}

/* CHANGE SC SOURCE SYSTEM ID SUPPORT */
export const changeVendorId = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    return Api.post(
      `/subcontractors/scVendorId`,
      payload,
      token
    ).then(response => {
      //console.log(response.data);
      const { success } = response.data;
      if(callback)callback(success);
    })
    .catch(error => {
    //console.log(error);
      if(callback)callback(false);
    });
  };
}

export const changeTaxId = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    return Api.post(
      `/subcontractors/update-country-and-tax-id`,
      payload,
      token
    ).then(response => {
      const { success } = response.data;
      if(callback) callback(success);
    })
    .catch(error => {
      if (error.response && error.response.status === 400 && error.response.data.type === "TAX_ID_EXISTS") {
        dispatch(setTaxIdExists({
          taxIdExists: true,
          existingSubcontractorId: error.response.data.existingSubcontractorId,
          existingSubcontractorName: error.response.data.existingSubcontractorName
        }));
      }
      if(callback) callback(false);
    });
  };
}

export const setTaxIdExists = (payload) => {
  return {
    type: types.SET_TAX_ID_EXISTS,
    taxIdExists: payload.taxIdExists,
    existingSubcontractorId: payload.existingSubcontractorId,
    existingSubcontractorName: payload.existingSubcontractorName
  }
}

export const mergeSubcontractors = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setIsMergingSubcontractors(true));

    return Api.post(
      `/subcontractors/merge-subcontractors`,
      payload,
      token
    ).then(response => {
      const { success } = response.data;
      dispatch(setMergeSubcontractorsSucceeded(true));
      dispatch(setIsMergingSubcontractors(false));
      if(callback) callback(success);
    })
    .catch(error => {
      dispatch(setMergeSubcontractorsSucceeded(false));
      dispatch(setIsMergingSubcontractors(false));
      if(callback) callback(false);
    });
  };
}

const setMergeSubcontractorsSucceeded = (success) => {
  return {
    type: types.SET_MERGE_SUBCONTRACTOTRS_SUCCEEDED,
    mergeSubcontractorsSucceeded: success
  }
}

const setIsMergingSubcontractors = (isMergingSubcontractors) => {
  return {
    type: types.SET_IS_MERGING_SUBCONTRACTORS,
    isMergingSubcontractors
  }
}

/* CHANGE STATUS SUPPORT */
export const changeStatus = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    return Api.post(
      `workflows/changescstatus`,
      payload,
      token
    ).then(response => {
      //console.log(response.data);
      const { success } = response.data;
      if(callback)callback(success);
    })
    .catch(error => {
    //console.log(error);
      if(callback)callback(false);
    });
  };
}

/* CHANGE NAME SUPPORT */
export const changeSCname = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    return Api.post(
      `/subcontractors/updateName`,
      payload,
      token
    ).then(response => {
      //console.log(response.data);
      const { success } = response.data;
      if(callback)callback(success);
    })
    .catch(error => {
    //console.log(error);
      if(callback)callback(false);
    });
  };
}

/* CHANGE TIER RATING SUPPORT */
export const changeTier = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    return Api.post(
      `subcontractors/changeTieRate`,
      payload,
      token
    ).then(response => {
      const { success } = response.data;
      if (callback) callback(success);
    })
      .catch(error => {
        if (callback) callback(false);
      });
  };
}

// CHECK IF THE USER MUST PAY THE HC FEE
const setPaymentStatus = (payment) => {
  return {
    type: types.SET_SC_PAYMENT_STATUS,
    payload: payment,
  };
};

const setPaymentError = (error) => {
  return {
    type: types.SET_SC_PAYMENT_STATUS_ERROR,
    payload: error,
  };
};

export const setLastPayment = (data) => {
  return {
    type: types.SET_SC_LAST_PAYMENT,
    payload: data,
  };
};

export const fetchPaymentStatus = (hiringClientId, subcontractorId, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    dispatch(setPaymentStatus(null));
    dispatch(setPaymentError(''));
    const url = `/users/mustpay?hiringClientId=${hiringClientId}&subcontractorId=${subcontractorId}`
    return Api.get(url, token)
    .then(response => {
      const { success, data } = response.data;
      if (success) {
        dispatch(setPaymentStatus(data));
        if (callback) callback(data);
      } else {
        dispatch(setPaymentError('Unable to get payment information'));
        if (callback) callback(null);
      }
    })
    .catch(() => {
      dispatch(setPaymentError('Unable to get payment information'));
      if (callback) callback(null);
    });
  };
}

export const setFetchingLocations = (isFetching) => {
  return {
    type: types.SET_FETCHING_LOCATIONS,
    isFetching
  };
};

export const setTotalAmountOfLocations = (locationsLength) => {
  return {
    type: types.SET_TOTAL_AMOUNT_OF_LOCATIONS,
    locationsLength
  };
};

export const setLocationsList = (list) => {
  return {
    type: types.SET_LOCATIONS_LIST,
    list
  };
};

export const setLocationsListError = (error) => {
  return {
    type: types.SET_LOCATIONS_LIST_ERROR,
    error
  };
};

export const setStatesList = (list) => {
  return {
    type: types.SET_US_STATES_LIST,
    list
  };
};

export const setCanProvAndTerrList = (list) => {
  return {
    type: types.SET_CANADIAN_PROVINCES_AND_TERRITORIES_LIST,
    list
  };
};

export const setCountriesList = (list) => {
  return {
    type: types.SET_COUNTRIES_LIST,
    list
  };
};

export const fetchLocations = (queryParams) => {
  // console.log('actions.fetchLocations queryParams = ', queryParams)
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    let urlParameters = '';

    dispatch(setFetchingLocations(true));
    dispatch(setTotalAmountOfLocations(0));

    if(queryParams) {
      if(!queryParams.pageNumber) {
        queryParams.pageNumber = 1;
      }
    }
    else {
      queryParams = {
        pageNumber: 1
      };
    }

    urlParameters = `?${Object.keys(queryParams).map(i => `${i}=${queryParams[i]}`).join('&')}`;
    // console.log('formFetch url = ', 'forms/savedforms' + urlParameters)
    return Api.get(`subcontractors/locations/list${urlParameters}`, token)
    .then(response => {
      const {success, data } = response.data;
      // console.log('fetchLocations response.data = ', response.data)
      let errorMsg = '';
      if(success) {
        dispatch(setTotalAmountOfLocations(data.totalCount));
        dispatch(setLocationsList(data.locations));
      }
      else {
        switch(data.errorCode) {
          case 10003:
            errorMsg = 'Error: invalid filter data. Please, adjust the filters values and try again.';
          break;
          case 10005:
            errorMsg = 'Error: This is an invalid session. Please, sign in again.';
          break;
          case 10006:
            errorMsg = 'Error: You are not logged in. Please, sign in and try again.';
            break;
          case 10007:
            errorMsg = 'Error: Session expired. Please, sign in and try again.';
            break;
          case 10140:
            errorMsg = `Error: Could not find Subcontractor's locations.  It is possible that we have no address for this Subcontractor.  Try adding one in the Locations Tab, by clicking on "Add location"`;
            break;
          default:
            errorMsg = '';
            break;
        }
        dispatch(setLocationsListError(errorMsg));
        dispatch(setTotalAmountOfLocations(0));
        dispatch(setLocationsList([]));
      }
      dispatch(setFetchingLocations(false));
    })
    .catch(error => {
    //console.log(error)
      dispatch(setLocationsListError('Connection error - Please, check your Internet service.'));
      dispatch(setTotalAmountOfLocations(0));
      dispatch(setLocationsList([]));
      dispatch(setFetchingLocations(false));
    });
  };
};

export const fetchStatesAndCountriesForRenderSelect = () => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    return Api.get(`subcontractors/statesAndCountries`, token)
    .then(response => {
      const { success, data } = response.data;
      // console.log('states & countries response.data = ', response.data)
      let errorMsg = '';
      if(success) {
        dispatch(setStatesList(data.states));
        dispatch(setCanProvAndTerrList(data.provAndTerr));
        dispatch(setCountriesList(data.countries));
      }
      else {
        switch(data.errorCode) {
          case 10003:
            errorMsg = 'Error: invalid filter data. Please, adjust the filters values and try again.';
          break;
          case 10005:
            errorMsg = 'Error: This is an invalid session. Please, sign in again.';
          break;
          case 10006:
            errorMsg = 'Error: You are not logged in. Please, sign in and try again.';
            break;
          case 10007:
            errorMsg = 'Error: Session expired. Please, sign in and try again.';
            break;
          case 10140:
            errorMsg = `Error: Could not find Subcontractor's locations.`;
            break;
          default:
            errorMsg = '';
            break;
        }
        dispatch(setLocationsListError(errorMsg));
        dispatch(setTotalAmountOfLocations(0));
        dispatch(setLocationsList([]));
      }
      dispatch(setFetchingLocations(false));
    })
    .catch(error => {
    //console.log(error)
      dispatch(setLocationsListError('Connection error - Please, check your Internet service.'));
      dispatch(setTotalAmountOfLocations(0));
      dispatch(setLocationsList([]));
      dispatch(setFetchingLocations(false));
    });
  };
};

export const setLocationError = (error) => {
  return {
    type: types.SET_LOCATIONS_ERROR,
    error
  };
};

export const setSavingLocation = (saving) => {
  return {
    type: types.SET_SAVING_LOCATION,
    saving
  };
};

export const setLatestSavedForm = latestSavedForm => {
  return {
    type: types.SET_LASTEST_SAVED_FORM,
    latestSavedForm
  }
}

export const setLatestSavedFormError = error => {
  return {
    type: types.SET_LASTEST_SAVED_FORM_ERROR,
    error
  }
}

export const deleteLocation = (payload) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setLocationError(null));
    const errMessage = 'Something went wrong.  Could not delete this location.  Please contact IT'
    if (payload.id) {
      Api.delete(
        `subcontractors/location/delete`,
        payload,
        token
      ).then(response => {
        const { success } = response.data
      //console.log('response.data = ', response.data)
        if (!success) {
        //console.log('success = ', success)
          dispatch(setLocationError(errMessage));
        }
      }).catch((error) => {
      //console.log('Error: ', error)

        dispatch(setLocationError(errMessage + ". Error trace: " + error));
      });
    }// else {
     // console.log('An Id for the Location to be deleted was not passed in.  Please provide an Id')
    //}

  };
}

export const setChangingPrimary = (isChanged) => {
  return {
    type: types.SET_CHANGING_PRIMARY,
    isChanged
  };
};

export const saveLocation = (payload, callback2) => {
  // console.log('payload = ', payload)
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    dispatch(setLocationError(null));
    dispatch(setSavingLocation(true));

    const errMessage = "There was an error while saving, please try again.  If the error persists, please contact IT"

    const callback = (err, data) => {
      if (err) {
      //console.log(err);
        dispatch(setLocationError(errMessage));
      } else {
        const { success } = data;
        if (!success) {
          dispatch(setLocationError(errMessage));
        } else {
          if (payload.Primary == 1) {
            dispatch(setChangingPrimary(true));
          }
        }
      }
      dispatch(setSavingLocation(false));
      // console.log('data = 1', data)
      if (callback2) {
        callback2()
      }
    }

    Api.post(
      `subcontractors/location`,
      payload,
      token
    ).then(response => {
    //console.log('response.data = ', response.data)
      callback(null, response.data);
    }).catch(error => {
      callback(error, null);
    });

  };
}

// Fetch Subcontractors Trades for the change trades modal
export const setChangeSubcontractorTradesListFetching = () => {
  return {
    type: types.SET_CHANGE_TRADES_MODAL_LIST_FETCHING,
  };
};

export const setChangeSubcontractorTradesListSuccess = (trades) => {
  return {
    type: types.SET_CHANGE_TRADES_MODAL_LIST_SUCCESS,
    trades,
  };
};

export const setChangeSubcontractorTradesListError = (error) => {
  return {
    type: types.SET_CHANGE_TRADES_MODAL_LIST_ERROR,
    error,
  };
};

export const fetchSCModalTradesList = ({ hiringClientId }) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();

    const {
      error10005,
      error10006,
      error10007,
      error10011,
      error10019,
      errorDefault,
      errorConnection,
    } = localization.strings.subcontractors.actions;

    const queryParams = { hiringClientId };

    const urlQuery = 'tradesbyhc';
    const urlParameters = `?${Object.keys(queryParams).map(i => `${i}=${queryParams[i]}`).join('&')}`;

    dispatch(setChangeSubcontractorTradesListFetching());

    return Api.get(`${urlQuery}${urlParameters}`, authToken)
    .then(response => {
      const { success, tradesList, data } = response.data;

      let errorMsg = '';

      if (success) {
        dispatch(setChangeSubcontractorTradesListSuccess(tradesList));
      } else {
        switch(data.errorCode) {
          case 10005:
            errorMsg = error10005;
          break;
          case 10006:
            errorMsg = error10006;
            break;
          case 10007:
            errorMsg = error10007;
            break;
          case 10011:
            errorMsg = error10011;
            break;
          case 10019:
            errorMsg = error10019;
            break;
          default:
            errorMsg = errorDefault;
            break;
        }

        dispatch(setChangeSubcontractorTradesListError(errorMsg));
      }
    }).catch((e) => {
    //console.log(e)
      dispatch(setChangeSubcontractorTradesListError(errorConnection));
    })
  };
};

// Fetch Subcontractors Trades for the change trades modal
export const setUpdateTradesFetching = () => {
  return {
    type: types.SET_UPDATE_TRADES_MODAL_FETCHING,
  };
};

export const setUpdateTradesSuccess = () => {
  return {
    type: types.SET_UPDATE_TRADES_MODAL_SUCCESS,
  };
};

export const setUpdateTradesError = (error) => {
  return {
    type: types.SET_UPDATE_TRADES_MODAL_ERROR,
    error,
  };
};

export const changeSubcontractorTrades = (payload, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();

    const {
      error10005,
      error10006,
      error10007,
      error10011,
      error10019,
      errorDefault,
      errorConnection,
    } = localization.strings.subcontractors.actions;

    dispatch(setUpdateTradesFetching());

    return Api.put('subcontractors/trades', payload, authToken)
    .then(response => {
      const { success, data } = response.data;

      let errorMsg = '';

      if (success) {
        dispatch(setUpdateTradesSuccess());
        callback(true);
      } else {
        switch(data.errorCode) {
          case 10005:
            errorMsg = error10005;
          break;
          case 10006:
            errorMsg = error10006;
            break;
          case 10007:
            errorMsg = error10007;
            break;
          case 10011:
            errorMsg = error10011;
            break;
          case 10019:
            errorMsg = error10019;
            break;
          default:
            errorMsg = errorDefault;
            break;
        }

        dispatch(setUpdateTradesError(errorMsg));
        callback(false);
      }
    }).catch((e) => {
    //console.log(e)
      dispatch(setUpdateTradesError(errorConnection));
      callback(false);
    })
  };
};

export const getHiringClientIds = scId => {
  return async (dispatch, getState) => {
    const token = getState().login.authToken;
    const urlQuery = `subcontractors/getHiringClientIds?scId=${scId}`
    try {
      const response = await Api.get(`${urlQuery}`, token);
      const { success, data } = response.data;
      if (success) {
        if (data.hcs.length == 1) {
          let hcId = data.hcs[0];
          if (typeof hcId === 'object') {
            hcId = hcId.HiringClientId;
          }
          dispatch(setHiringClientId(hcId));
        } else {
          dispatch(setHiringClients(data.hcs));
        }
        return data.hcs;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
};

export const getLatestSavedForm = (hcId, scId) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;
    Api.get(
      `forms/getLatestSavedForm?hcId=${hcId}&scId=${scId}`,
      token
    ).then(response => {
      const {success, savedForm} = response.data
      if(success && savedForm) {
        dispatch(setLatestSavedForm(savedForm));
      } 
    })
    .catch(error => {
      dispatch(setLatestSavedFormError(error))
    });
  };
}

export const setMovingSubContractorToHiringClient = (isSCMoving) => {
  return {
    type: types.SET_MOVING_SC_TO_HIRINGCLIENT,
    isSCMoving
  };
};

export const setIsSubContractorMoved = (isSCMoved) => {
  return {
    type: types.SET_IS_SUBCONTRACTOR_MOVED,
    isSCMoved
  };
};
export const setHasTemplateDisconnect = (hasTemplateDisconnect) => {
  return {
    type: types.SET_HAS_TEMPLATE_DISCONNET,
    hasTemplateDisconnect
  };
};

export const setSubContractorMoveFailed = (scMoveError) => {
  return {
    type: types.SET_SUBCONTRACTOR_MOVE_FAILED,
    scMoveError
  };
};

export const setSubContractorHasHiringClientSiblings = (value) => {
  return {
    type: types.SET_SUBCONTRACTOR_HAS_HC_SIBLINGS,
    scHasHCSiblings: value
  };
};

export const moveSubContractorToHiringClient = (params) => {
  return async (dispatch, getState) => {
    dispatch(setMovingSubContractorToHiringClient(true));
    const { login: { authToken } } = getState();

    try {
      const {subContractorId, source, target, trades} = params;
      const qs = new URLSearchParams({source, target});
      const payload = {...trades}
      const response =  await Api.put(`subcontractors/${subContractorId}/move?${qs}`, payload, authToken);
      
      if( response.data.data && response.data.data.haveFileDisconnect){
        dispatch(setHasTemplateDisconnect(true));
      }
      dispatch(setIsSubContractorMoved(true));
    } catch (error) {
      const local = getState().localization.strings;
      const {errorOnMove} = local.scProfile.header.selectMoveToHiringClient;
      dispatch(setSubContractorMoveFailed(errorOnMove));
    }

    dispatch(setMovingSubContractorToHiringClient(false));
  };
};

/* CHANGE NAME SUPPORT */
export const changeSCCompanyName = (payload, callback) => {
  return (dispatch, getState) => {
    const token = getState().login.authToken;

    return Api.put(
        `subcontractors/updatecompanyname`,
        payload,
        token
    ).then(response => {
      //console.log(response.data);
      const { success } = response.data;
      if(callback)callback(success);
    })
        .catch(error => {
          //console.log(error);
          if(callback)callback(false);
        });
  };
}
